function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class AwaitableStream {
    emit(value) {
        this.messages.push(value);
        // For each queue, resolve the first promise that matches the condition
        for (const [callerName, queue] of Array.from(this.queues.entries())){
            for (const item of queue){
                if (item.condition(value)) {
                    item.resolve(value);
                    this.lastReadIndices.set(callerName, this.messages.length - 1);
                    queue.splice(queue.indexOf(item), 1);
                    return;
                }
            }
        }
    }
    awaitFor(callerName, conditionFunction) {
        var _this = this;
        return _async_to_generator(function*() {
            // If this is the first time this caller is reading a message, initialize their last read index and queue
            if (!_this.lastReadIndices.has(callerName)) {
                _this.lastReadIndices.set(callerName, -1);
                _this.queues.set(callerName, []);
            }
            // Start from the message after the last one this caller read
            for(let i = (_this.lastReadIndices.get(callerName) || -1) + 1; i < _this.messages.length; i++){
                // If this message matches the condition
                if (conditionFunction(_this.messages[i])) {
                    // Update the last read index and return the message
                    _this.lastReadIndices.set(callerName, i);
                    return _this.messages[i];
                }
            }
            // If no unread message matches the condition, add a promise to the queue
            return new Promise((resolve, reject)=>{
                var _this_queues_get;
                (_this_queues_get = _this.queues.get(callerName)) === null || _this_queues_get === void 0 ? void 0 : _this_queues_get.push({
                    resolve,
                    condition: conditionFunction
                });
            });
        })();
    }
    constructor(){
        _define_property(this, "messages", void 0);
        _define_property(this, "lastReadIndices", void 0);
        _define_property(this, "queues", void 0);
        this.messages = [];
        this.lastReadIndices = new Map();
        this.queues = new Map();
    }
}
